import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { AddptaxmaindetailsComponent } from '../addptaxmaindetails/addptaxmaindetails.component';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
@Component({
  selector: 'app-addptaxmain',
  templateUrl: './addptaxmain.component.html',
  styleUrls: ['./addptaxmain.component.css']
})
export class AddptaxmainComponent implements OnInit, AfterViewInit {

  @ViewChildren('input') firstipcontrol;

  formname: String = "ProfessionalTax";


  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;


  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;


  ptaxdetailsColl:any=[];
  //Edit Get Values
  ptaxColl: any = [];
  ptaxBO: any = {};
  ptaxid: number = 0

  ptaxform = new FormGroup({
    ptaxid: new FormControl(0),
    fromdate: new FormControl('', Validators.required),
    todate: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });

  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal, private datePipe: DatePipe,
    private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.ptaxid = params.id
      }
    });

    this.fnServiceChanges();

    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
  }


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.ptaxform.reset();
      this.fnInitializeFormGroup();

      if (this.ptaxid > 0) {
        this.fngetPtax();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.ptaxid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  ngAfterViewInit() {
   // //this.firstipcontrol.first.nativeElement.focus();
  }
  fnInitializeFormGroup() {
    this.ptaxform.setValue({
      ptaxid: 0,
      fromdate: '',
      todate: '',
      inactive: false
    })
  }


  //Get 
  fngetPtax() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'ptaxid': this.ptaxid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getPtaxmain(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.ptaxColl = res.json().result[0];
            this.ptaxdetailsColl = res.json().result[1];
            

            var editdata = this.ptaxColl[0];
            this.fnEditMode(editdata);
            this.ptaxBO = editdata;
          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }




  //Save Btn Click
  fnSaveBtnClick() {
    try { if (this.saveloading) {
      return;
    }
      this.submitted = true;
      this.successfully = false;
      if (this.loginService.fnCheckFornControlNotfound(this.ptaxform.get('todate'))) {
        this.ptaxform.controls['todate'].setErrors(null);
      }
     
      //Validate
      if (this.ptaxform.valid) {
              
        if(this.loginService.fnCompareDateValidation(this.ptaxform.get('todate').value,this.ptaxform.get('fromdate').value)){
          this.ptaxform.controls['todate'].setErrors({'notfound': true});
          return
        }
        
        this.saveloading = true;

        //Check
        var data = {
          'ptaxid': this.ptaxid,
          'fromdate': this.fnFormatDatetime(this.ptaxform.get('fromdate').value),
          'todate': this.fnFormatDatetime(this.ptaxform.get('todate').value),
          'inactive': this.ptaxform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
          'ptaxdetailscoll':this.ptaxdetailsColl
        }


        this.appService.fnCheckReligion(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresult = res.json().result[0].checkfield;

              if (_checkresult === "done") {
                if (this.ptaxform.get('ptaxid').value > 0) {
                  //Update 
                  this.fnSetPtax(data);
                }
                else {
                  //Insert 
                  this.fnInsertPtax(data);
                }
              }
              else {
                if (_checkresult === "todate") {this.saveloading = false;
                  this.ptaxform.controls['todate'].setErrors({ 'notfound': true });
                }
              }
            }
            else {this.saveloading = false;
              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {this.saveloading = false;
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {this.saveloading = false;
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertPtax(data) {

    this.appService.fnInsertPtaxmain(data).subscribe(
      (res) => {this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The new from date has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, data.fromdate);
            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetPtax(data) {

    this.appService.fnSetPtaxmain(data).subscribe(
      (res) => {this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The religion has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.ptaxid, data.fromdate);
            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }


  //Close
  fnCloseForm() {
    try {
      this.router.navigate(['/ProfessionalTax']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnAddPtaxDetails() {

    const modalRef = this.productFindService.open(AddptaxmaindetailsComponent, { size: <any>'l' });

    modalRef.componentInstance.ptaxdetailsColl = this.ptaxdetailsColl;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      this.ptaxdetailsColl.push(receivedEntry);
      
    });
    
  }

  fnEditPtaxDetails(index) {


    const modalRef = this.productFindService.open(AddptaxmaindetailsComponent, { size: <any>'l' });

    var data = this.ptaxdetailsColl[index];

    modalRef.componentInstance.ptaxdetid = data.ptaxdetid;
    modalRef.componentInstance.ptaxtype = data.ptaxtype;
    modalRef.componentInstance.rangefrom = data.rangefrom;
    modalRef.componentInstance.rangeto = data.rangeto;
    modalRef.componentInstance.taxamt = data.taxamt;



    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {


      this.ptaxdetailsColl[index].ptaxdetid = receivedEntry.ptaxdetid;
      this.ptaxdetailsColl[index].ptaxtype = receivedEntry.ptaxtype;
      this.ptaxdetailsColl[index].rangefrom = receivedEntry.rangefrom;
      this.ptaxdetailsColl[index].rangeto = receivedEntry.rangeto;
      this.ptaxdetailsColl[index].taxamt = receivedEntry.taxamt;

     

    });

  }

  fnDeletePtaxConfirm(index) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete details?')
        .then((confirmed) => {
          if (confirmed) {
            this.ptaxdetailsColl.splice(index, 1)
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnDeletePtaxDetails(index) {



  }


  private fnEditMode(deptBO) {

    deptBO.fromdate = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.fromdate));
    deptBO.todate = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.todate));

    console.log(deptBO)
    this.ptaxform.setValue({
      ptaxid: deptBO.ptaxid,
      fromdate: deptBO.fromdate,
      todate: deptBO.todate,
      inactive: deptBO.inactive
    });

    this.formmode = "Edit";

    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }
  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }
  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}
